import { render, staticRenderFns } from "./disStaticsSuper.vue?vue&type=template&id=480f591c&scoped=true"
import script from "./disStaticsSuper.vue?vue&type=script&lang=js"
export * from "./disStaticsSuper.vue?vue&type=script&lang=js"
import style0 from "./disStaticsSuper.vue?vue&type=style&index=0&id=480f591c&prod&lang=scss&scoped=true"
import style1 from "./disStaticsSuper.vue?vue&type=style&index=1&id=480f591c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f591c",
  null
  
)

export default component.exports